import { buildPreviewBookingPrefill, buildPreviewConfirmedBooking } from '../../utils/previewMode';
import { bookingSteps } from '../models/Booking';
import store from '../store';
import * as type from './types';

/**
 * Preview mode only: jumps the widget to a step with the booking state prefilled
 * (fake guest details, selected time and experience) so the step renders fully
 * without any interaction.
 * @param {number} step target bookingSteps value
 */
export const applyPreviewStepAction = (step) => (dispatch) => {
  const restaurantData = store.getState()?.restaurant?.data ?? {};

  dispatch({
    type: type.BATCH_UPDATE_BOOKING,
    payload: { ...buildPreviewBookingPrefill(restaurantData), step },
  });

  // The confirmation screen renders from the created booking, so mock one
  if (step === bookingSteps.confirm) {
    dispatch({
      type: 'CREATE_OBEE_BOOKING_SUCCESS',
      payload: buildPreviewConfirmedBooking(restaurantData),
    });
  }
};

export const clearBookingAction = () => (dispatch) => {
  dispatch({
    type: type.CLEAR_BOOKING,
  });
};

export const editBookingAction = () => (dispatch) => {
  dispatch({
    type: type.EDIT_BOOKING,
  });
};

export const editWaitlistAction = () => (dispatch) => {
  dispatch({
    type: type.EDIT_WAITLIST,
  });
};

export const removeAddonAction = (addonId) => (dispatch) => {
  dispatch({
    type: type.REMOVE_ADDON,
    payload: addonId,
  });
};

export const updateBookingAction = (key, value) => (dispatch) => {
  dispatch({
    type: type.UPDATE_BOOKING,
    payload: { key, value },
  });
};

export const batchUpdateBookingAction = (keyValues) => (dispatch) => {
  dispatch({
    type: type.BATCH_UPDATE_BOOKING,
    payload: keyValues,
  });
};

export const updateBookingStepAction =
  (step, subStep = null) =>
  (dispatch) => {
    dispatch({
      type: type.UPDATE_BOOKING_STEP,
      payload: { step, subStep },
    });
  };

export const updateBookingSubStepAction =
  (subStep = null) =>
  (dispatch) => {
    dispatch({
      type: type.UPDATE_BOOKING_SUB_STEP,
      payload: { subStep },
    });
  };
